<template>
    <div id="game-container"></div>
</template>

<script>
    import "phaser"
    import MainScene from "../scenes/MainScene";
    import GameScalePlugin from 'phaser-plugin-game-scale';

    export default {
        name: "Game",

        data() {
            let isMobile = this.isMobile();

            let isIE = false;
            if (window.navigator.userAgent.indexOf("MSIE ") > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                isIE = true;
            }

            let game = new Phaser.Game({
                type: isIE ? Phaser.CANVAS : Phaser.AUTO,
                width: isMobile ? window.innerWidth : 1600,
                height: isMobile ? window.innerHeight : 900,
                backgroundColor: "#152649",
                resolution: window.devicePixelRatio,
                physics: {
                    default: "arcade",
                    arcade: {
                        debug: false,
                        gravity: {y: 0}
                    }
                },
                plugins: {
                    global: [{
                        key: 'GameScalePlugin',
                        plugin: GameScalePlugin,
                        mapping: 'gameScale',
                        data: {
                            debounce: false,
                            debounceDelay: 50,   // Debounce interval, in ms
                            maxHeight: isMobile ? 1920 : 1080,
                            maxWidth: isMobile ? 1080 : 1920,
                            minHeight: 200,
                            minWidth: 400,
                            mode: 'fit',
                            resizeCameras: true,
                            snap: null,
                        }
                    }]
                },
                canvasStyle: 'visibility:hidden',
                audio: {
                    disableWebAudio: isIE
                },
                scene: MainScene,
            });

            //Attach the vue instance to game, so we could easily access it from within the scene
            game._vm = this;

            game.isMobile = this.isMobile;

            //Store the original device type
            game.was_mobile = isMobile;

            //Is the browser IE?
            game.is_ie = isIE;

            //Toggle god mode on/off (Won't lose lives)
            game.god_mode = false;

            //Toggle endless mode (Game will never end)
            game.endless_mode = false;

            //Toggle record mode on/off
            game.record_mode = this.$route.query.record ? this.$route.query.record : false;

            //Toggle record mode on/off
            game.playback_mode = !!this.$route.query.playback

            //Toggle debug mode on/off
            game.debug_mode = !!this.$route.query.debug;

            //Toggle arrow file skipping and automatic arrow generation on/off
            game.generate_arrows = false;

            //Toggle autoclicker on/off
            game.autoclick = false;

            return {
                resize_interval: null,
                game: game,
                paused_at: null
            }
        },

        mounted() {
            $('body').addClass('with-bg');

            window.addEventListener('resize', this.resize);
            window.addEventListener('orientationchange', this.delayedResize);

            $(window).blur(() => {
                this.pause();
            });

            $(window).focus(() => {
                this.resume();
            });

            this.$nextTick(() => {
                this.checkCanvas();

                this.resize_interval = setInterval(() => {
                    this.centerCanvas();
                }, 500);
            });
        },

        destroyed() {
            window.removeEventListener('resize', this.resize);
            window.removeEventListener('orientationchange', this.delayedResize);
            window.removeEventListener('onblur', this.resize);

            clearInterval(this.resize_interval);
        },

        methods: {
            delayedResize() {
                setTimeout(() => {
                    window.location.reload();
                }, 100)
            },

            resume() {
                try {
                    let idleTime = Date.now() - this.paused_at;

                    this.game.scene.scenes.forEach(scene => {
                        scene.scene.scene.start_time = parseInt(scene.scene.scene.start_time) + parseInt(idleTime);
                        scene.scene.resume();
                    });
                } catch (e) {
                    //do nothing
                }
            },

            pause() {
                try {
                    this.game.scene.scenes.forEach(scene => {
                        scene.scene.pause();
                    });

                    this.paused_at = Date.now();
                } catch (e) {
                    //do nothing
                }
            },

            resize() {
                let isMobile = this.isMobile();

                try {
                    this.game.resize((isMobile ? window.innerWidth : 1600), (isMobile ? window.innerHeight : 900));

                    this.game.scene.scenes.forEach(scene => {
                        if (scene.audio) {
                            scene.audio.intro.stop();
                            scene.audio.song.stop();
                        }

                        scene.scene.restart();
                    });
                } catch (e) {
                    //do nothing
                }

                this.centerCanvas();
            },

            centerCanvas() {
                if (!$('canvas').length) {
                    return false;
                }

                let isMobile = this.isMobile();
                let container = $('body');
                let canvas = $('canvas');
                let ratio = parseFloat(canvas.css('transform').substr(7).split(',')[0]);

                let canvasWidth = parseInt(canvas.outerWidth() * ratio);
                let canvasHeight = parseInt(canvas.outerHeight() * ratio);

                if (isNaN(canvasWidth)) {
                    canvasWidth = canvas.outerWidth();
                }

                if (isNaN(canvasHeight)) {
                    canvasHeight = canvas.outerHeight();
                }

                if (isMobile) {
                    container.css('padding-left', 0);
                    container.css('padding-top', 0);

                    canvas.css('visibility', 'visible');

                    return true;
                }

                if (window.innerHeight > canvasHeight) {
                    container.css('padding-top', (window.innerHeight - canvasHeight) / 2);
                } else {
                    container.css('padding-top', 0);
                }

                if (window.innerWidth > canvasWidth) {
                    container.css('padding-left', (window.innerWidth - canvasWidth) / 2);
                } else {
                    container.css('padding-left', 0);
                }

                if (window.innerHeight > container[0].getBoundingClientRect().height) {
                    container.css('height', window.innerHeight);
                }

                canvas.addClass('with-border');

                setTimeout(() => {
                    canvas.css('visibility', 'visible');
                }, 300);
            },

            checkCanvas() {
                if ($('canvas').length) {
                    this.centerCanvas();
                } else {
                    setTimeout(() => {
                        this.checkCanvas();
                    }, 10);
                }
            },

            isMobile() {
                if (navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i)) {
                    return true;
                }

                return window.innerWidth <= 800;
            }
        }
    }
</script>

<style>
    canvas {
        display: block;
    }

    canvas.with-border {
        border-bottom: 8px solid #162748;
        background-image: linear-gradient(transparent, 90%, #162748), linear-gradient(transparent, 90%, #162748);
        background-size: 8px 100%;
        background-position: 0 0, 100% 0;
        background-repeat: no-repeat;
        border-radius: 0 0 6px 6px;
        padding: 0 8px;
    }

    body.with-bg {
        background-image: url("../assets/svg/bg-pattern.svg");
        background-image: url("../assets/svg/bg-pattern.svg"), linear-gradient(178.75deg, #152649 0%, #234892 100%);
        background-repeat: repeat;
    }
</style>